import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faSignOutAlt,
  faCaretRight,
  faCaretDown,
  faCaretLeft,
  faUpload,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import '../sass/base.scss';
import store from './store';

Vue.config.productionTip = false;
Vue.config.devtools = true;

library.add(
  faSignOutAlt,
  faCaretRight,
  faCaretDown,
  faCaretLeft,
  faUpload,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
